<template>
  <LoadingSpinner v-if="loading" />
  <v-row v-else-if="error">
    <v-col cols="12">
      <v-alert type="error">
        {{ error }}
      </v-alert>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col cols="12">
      <v-card>
        <v-card-title> Print Order #{{ order.id }} </v-card-title>
        <v-simple-table>
          <template #default>
            <tbody>
              <tr>
                <td>Date</td>
                <td>{{ order.orderDate | normalDateWithTime }}</td>
              </tr>
              <tr v-if="order.jobs">
                <td>Customer</td>
                <td>
                  <router-link :to="`/users/${order.jobs[0].userInfoId}`">
                    {{ order.jobs[0].username }}
                  </router-link>
                </td>
              </tr>
              <tr>
                <td>Charge Id</td>
                <td>{{ order.stripeChargeId }}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td>{{ order.totalPrice | currency }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> Print Jobs </v-card-title>
        <v-data-table
          :items="tableJobs"
          :headers="headers"
          :items-per-page="1000"
          :sort-by="['id']"
          :sort-desc="[true]"
          item-key="id"
          class="row-pointer"
          mobile-breakpoint="0"
          hide-default-footer
          @click:row="rowClick"
        >
          <template #[`item.tracking`]="{ item }">
            <a
              v-if="item.trackingUrl"
              :href="item.trackingUrl"
              target="_blank"
            >
              {{ item.trackingNumber }}
            </a>
            <span v-else> Unavailable </span>
          </template>
          <template #[`item.actions`]="{}">
            <v-icon>chevron_right</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import enums from '@/helpers/enums';
export default {
  name: 'OrdersDetail',
  components: {},
  data: () => ({
    loading: true,
    error: '',
    headers: [
      { text: 'Job Id', value: 'id' },
      { text: 'Price', value: 'price' },
      { text: 'Product', value: 'product' },
      { text: 'Quantity', value: 'price' },
      { text: 'Provider', value: 'provider' },
      { text: 'Status', value: 'status' },
      { text: 'Tracking', value: 'tracking' },
      { text: '', value: 'actions' }
    ]
  }),
  computed: {
    tableJobs() {
      var jobs = [];
      if (this.order.jobs.length) {
        jobs = this.order.jobs.map((x) => ({
          id: x.jobId,
          orderId: x.orderId,
          price: this.$options.filters.currency(x.price),
          product: x.categoryName,
          quantity: x.quantity,
          provider: x.provider,
          status: x.status,
          trackingUrl: x.trackingUrl,
          trackingNumber: x.trackingNumber
        }));
      }
      return jobs;
    },
    ...mapGetters({
      order: 'orders/order'
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.error = '';
      this.$store
        .dispatch('orders/get', this.$route.params.id)
        .catch((error) => {
          this.error = 'Error finding or loading order';
          this.logError(error, true);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$store.dispatch('drawers/open', {
        drawerId: enums.DRAWERS.PRINT_JOB_DETAIL,
        data: { orderId: item.orderId, jobId: item.id }
      });
    }
  }
};
</script>
